






































































































import {AccountTypeEnum, PartyCareProviderModel, PartyModel, TenantModel, TenantUserModel} from '@/libs/Api';
import {partiesStore} from '@/libs/parties/+state/store';
import {CrudAction, CrudReponse} from '@/libs/core/+state/models/crud-action';
import {CrudGetter} from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import {Component, Prop, Watch} from 'vue-property-decorator';

import PartyCreateDialog from '@/libs/parties/components/PartyCreateDialog.vue';
import {authStore} from '@/libs/auth/+store/store';
import {AuthGetter} from '@/libs/auth/models/auth-state';
import {cloneDeep} from "lodash";
import {compare} from "fast-json-patch";
import {val} from "dom7";
import {Guid} from "@/libs/common/functions/guid";
import {tenantsStore} from "@/libs/tenants/+state/store";

@Component({
    methods: {val},
    components: {
        PartyCreateDialog
    }
})
export default class Party extends Page {

    @Prop() tenantId!: string;
    @Prop() partyId!: string;
    loading = true;
    originalPartyModel: PartyModel | null = null;
    validationErrorDialog = false;
    validationErrors: string[] = [];
    partyMainCareProviders: PartyCareProviderModel[] = [];
    unsavedChangesDialog = false;
    nextPath: string | null = null;
    unsavedChangesDecline = false;

    @Watch("partyId")
    partyIdChanged () {
        this.loading = true;
        this.loadParty();
    }

    get tenantUser (): TenantUserModel {
        return authStore.useGetter(AuthGetter.GetTenantUser);
    }

    get party (): PartyModel {
        return partiesStore.useGetter(CrudGetter.Detail);
    }

    get canEdit (): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        const tenant = tenantsStore.useGetter(CrudGetter.Detail, this.tenantId) as TenantModel;
        if (tenantUser.accountType == AccountTypeEnum.Volunteer) {
            return false;
        }
        else if (tenantUser.accountType == AccountTypeEnum.Worker) {
            if (tenant.enableEditClientByWorker && this.party?.mainCareProviderId == tenantUser.userId) {
                return true;
            }
            else if (tenant.enableEditClientOfAnotherWorkers && this.party?.districtId == tenantUser.mainDistrictId) {
                return true;
            }
            else {
                return false;
            }
        }
        return true;
    }
    
    get isChanged(): boolean {
        const currentPartyModel = partiesStore.useGetter(CrudGetter.Detail);
        if (this.originalPartyModel && currentPartyModel) {
            // console.log(compare(this.originalPartyModel!, currentPartyModel));
            return compare(this.originalPartyModel!, currentPartyModel).count() > 0;
        }
        return false;
    }
    
    get saving(): boolean {
        return partiesStore.useGetter(CrudGetter.Saving);
    }

    mounted () {
        this.$router.beforeEach((to, from, next) => {
            const fromPath = from.fullPath.split('/');
            const toPath = to.fullPath.split('/');
            if (fromPath.length === toPath.length && fromPath[2] === toPath[2]) {
                next();
            } else {
                if (this.isChanged && !this.unsavedChangesDecline) {
                    this.nextPath = to.fullPath;
                    this.unsavedChangesDialog = true;
                } else {
                    next();
                }
            }
            
        });
        this.loadParty();
    }

    loadParty () {
        partiesStore.dispatch(CrudAction.Get, { id: this.partyId });
        this.subscribe(partiesStore, CrudReponse.Get).then((e: PartyModel) => {
            this.originalPartyModel = cloneDeep(e);
            // console.log(this.party.partyCareProviders, this.party?.mainCareProviderId);
            // this.partyMainCareProviders = [...this.party.partyCareProviders!].toArray();
            // console.log("partyMainCareProviders", this.partyMainCareProviders);
            this.loading = false;
        });
    }
    
    save () {
        const validationErrors = [];
        if (!this.party.firstName) {
            validationErrors.push("Pole jméno musí být vyplněno.");
        }
        if (!this.party.lastName) {
            validationErrors.push("Pole příjmení musí být vyplněno.");
        }
        if (!this.party.districtId) {
            validationErrors.push("Pole středisko musí být vyplněno.");
        }
        if (validationErrors.any()) {
            this.validationErrorDialog = true;
            this.validationErrors = validationErrors;
        }
        else {
            const careProviders = this.party.partyCareProviders!;
            /*
            const partyMainCareProvidersIds = this.partyMainCareProviders.select(x => x.id).toArray();
            careProviders = careProviders!.where(x => !partyMainCareProvidersIds.contains(x.id)).toArray();
            if (this.partyMainCareProviders.count() > 0 && this.partyMainCareProviders.first().userId == this.party!.mainCareProviderId) {
                careProviders.push(this.partyMainCareProviders.first());
            }
            else */
            if (this.party!.mainCareProviderId != null && !careProviders.any(x => x.userId == this.party!.mainCareProviderId)) {
                careProviders.push({
                    id: Guid.EmptyGuid(),
                    userId: this.party?.mainCareProviderId,
                    canProvideChargedTasks: true,
                    canProvideFreeTasks: true,
                    partyId: this.partyId
                })
            }
            this.party.partyCareProviders = careProviders;
            partiesStore.dispatch(CrudAction.Update, { item: this.party });
            this.subscribe(partiesStore, CrudReponse.Update).then(x => {
                // debugger;
                this.originalPartyModel = cloneDeep(x);
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.unsavedChangesDialog = false;
                    if (this.nextPath) {
                        this.$router.push(this.nextPath);
                        this.nextPath = null;
                    }
                }, 500);
            });
        }
    }

    unsavedChangesDeclined () {
        if (this.nextPath) {
            this.unsavedChangesDecline = true;
            this.unsavedChangesDialog = false;
            this.$router.push(this.nextPath!);
        }
    }

}
